import styled from 'styled-components';

export const StyledCell = styled.p`
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
`;
